import { OpsApiError } from '../api/client.ts';

/**
 * The rated-anchor guards' payload, recovered from their message.
 *
 * `MODEL_PRICING_RATED_ANCHOR_CONFLICT` (platform `models/model-pricing.ts`)
 * and its unit twin `MODEL_UNIT_PRICING_RATED_ANCHOR_CONFLICT`
 * (`models/model-unit-pricing.ts`) carry the latest rated event instant only
 * INSIDE the message string — the error envelope has no structured details
 * member for it:
 *
 *   `... (latest rated event <ISO>); append a generation strictly after ...`
 *
 * The console translates that into an operator-readable sentence instead of
 * showing the raw code, on BOTH pricing forms. Returns the extracted ISO
 * instant, `null` for any other error, and `''` for a conflict whose instant
 * cannot be recovered (message shape drifted) — still a conflict, just
 * without the timestamp.
 */
const RATED_ANCHOR_CONFLICT_CODES: ReadonlySet<string> = new Set([
  'MODEL_PRICING_RATED_ANCHOR_CONFLICT',
  'MODEL_UNIT_PRICING_RATED_ANCHOR_CONFLICT',
]);

export function ratedAnchorConflictLatestIso(err: unknown): string | null {
  if (!(err instanceof OpsApiError) || !RATED_ANCHOR_CONFLICT_CODES.has(err.code)) {
    return null;
  }
  const match = /latest rated event ([^);\s]+)\)/.exec(err.message);
  const iso = match?.[1];
  if (iso === undefined || !Number.isFinite(Date.parse(iso))) return '';
  return iso;
}
